module.exports = __webpack_public_path__ + "e964dfb011d146369de167025f29803d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cylindre-bouton.png
// module id = 813
// module chunks = 0